import { Dispatch } from 'redux';
import EApiMiddlewareMethod from 'config/redux/middlewares/api.middleware.enum';
import { IAppState } from 'config/redux/reducers';
import { getCartId } from 'pages/Cart/helpers/url.helpers';
import { USER_PACKGING_CONSENT } from 'pages/Checkout/constants/apis.constant';
import { updateCart } from 'pages/Cart/redux/actions/getCart.action';
import { hidePageLoader, showPageLoader } from 'common/PageLoader/redux/pageLoader.action';

export const userConsentAction = (
  params: {
    isSustainableConsent?: boolean;
    successCallback?: () => void;
  } = {}
) => (dispatch: Dispatch, getState: () => IAppState) => {
  const store = getState();
  const { areaCode } = store.appConfig;
  const { isSustainableConsent, successCallback } = params;
  dispatch(showPageLoader());
  dispatch({
    type: 'EValidateCartActionTypes.DELIVER_TO_VALIDATE_CART_GET_ENTRIES',
    payload: {
      method: EApiMiddlewareMethod.PUT,
      onSuccess: (res: any) => {
        updateCart(dispatch, res);
        if (successCallback) {
          successCallback();
        }
      },
      onFinally: () => {
        dispatch(hidePageLoader());
      },
      params: {
        cartId: getCartId(store),
        sustainabilityConsent: isSustainableConsent,
        areaCode,
      },
      url: USER_PACKGING_CONSENT,
    },
  });
};
